/* Nebulosa por shader (WebGL).
   El color se calcula pixel a pixel en la GPU con ruido fractal (FBM),
   que es lo que da volumen y densidad reales. Un canvas 2D dibujando
   puntos no puede conseguir esto por muchos efectos que se le anadan. */
window.C3DNebula = function (canvas) {
  var gl = canvas.getContext('webgl', { alpha: true, antialias: false, powerPreference: 'high-performance' })
        || canvas.getContext('experimental-webgl');
  if (!gl) return null;

  var VERT = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';

  var FRAG = [
    'precision highp float;',
    'uniform vec2  u_res;',
    'uniform float u_time;',
    'uniform float u_prog;',
    'uniform vec2  u_mouse;',
    'uniform vec3  u_ca;',
    'uniform vec3  u_cb;',

    'float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
    ' return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.,1.)),f.x),f.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<6;i++){v+=a*noise(p);p*=2.03;a*=.5;}return v;}',

    'void main(){',
    ' vec2 uv=(gl_FragCoord.xy-.5*u_res)/u_res.y;',
    ' float t=u_time*.016;',
    ' uv*= 1.0 - u_prog*.30;',                       /* al bajar te adentras */
    ' vec2 q=uv*1.7;',
    ' q+=vec2(fbm(q+t),fbm(q-t*1.2))*.55;',          /* dominio deformado = volutas */
    ' float n=fbm(q*1.35+t*.5);',
    ' float n2=fbm(q*3.1-t*.35);',
    ' vec3 col=mix(u_ca,u_cb,clamp(n*1.45,0.,1.));',
    ' col*=smoothstep(.14,.86,n)*1.25;',
    ' col+=u_cb*pow(n2,3.)*.7;',
    ' col*=.55+.45*u_prog;',

    /* estrellas con parpadeo, en rejilla hash */
    ' vec2 sp=uv*vec2(u_res.x/u_res.y,1.)*78.;',
    ' vec2 si=floor(sp),sf=fract(sp)-.5;',
    ' float h=hash(si);',
    ' float star=smoothstep(.40,0.,length(sf))*step(.982,h);',
    ' float tw=.55+.45*sin(u_time*1.9+h*47.);',
    ' col+=vec3(1.)*star*tw*(1.1+u_prog*1.1);',

    /* halo suave siguiendo al raton */
    ' float md=length(uv-u_mouse);',
    ' col+=u_cb*.30*exp(-md*5.5)*u_prog;',

    ' col*=1.0-smoothstep(.55,1.25,length(uv))*.55;', /* vineteado */
    ' gl_FragColor=vec4(col,1.);',
    '}'
  ].join('\n');

  function compile(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src); gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
      console.warn('[hero-3d] shader:', gl.getShaderInfoLog(s)); return null;
    }
    return s;
  }
  var vs = compile(gl.VERTEX_SHADER, VERT), fs = compile(gl.FRAGMENT_SHADER, FRAG);
  if (!vs || !fs) return null;

  var prog = gl.createProgram();
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return null;
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'p');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

  var U = {
    res:   gl.getUniformLocation(prog, 'u_res'),
    time:  gl.getUniformLocation(prog, 'u_time'),
    prog:  gl.getUniformLocation(prog, 'u_prog'),
    mouse: gl.getUniformLocation(prog, 'u_mouse'),
    ca:    gl.getUniformLocation(prog, 'u_ca'),
    cb:    gl.getUniformLocation(prog, 'u_cb')
  };

  function hex2rgb(h){
    h = String(h || '').replace('#','');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var n = parseInt(h, 16);
    if (isNaN(n)) return [1,0,1];
    return [((n>>16)&255)/255, ((n>>8)&255)/255, (n&255)/255];
  }

  var dpr = Math.min(window.devicePixelRatio || 1, 1.5);

  return {
    resize: function () {
      var w = Math.round(canvas.offsetWidth * dpr);
      var h = Math.round(canvas.offsetHeight * dpr);
      if (!w || !h) return;
      canvas.width = w; canvas.height = h;
      gl.viewport(0, 0, w, h);
      gl.uniform2f(U.res, w, h);
    },
    colors: function (a, b) {
      var ca = hex2rgb(a), cb = hex2rgb(b);
      gl.uniform3f(U.ca, ca[0]*0.55, ca[1]*0.55, ca[2]*0.55);
      gl.uniform3f(U.cb, cb[0], cb[1], cb[2]);
    },
    draw: function (timeMs, progress, mx, my) {
      gl.uniform1f(U.time, timeMs * 0.001);
      gl.uniform1f(U.prog, progress);
      gl.uniform2f(U.mouse, mx, my);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
  };
};
